import { render, staticRenderFns } from "./systemUserMember.vue?vue&type=template&id=12100106&scoped=true"
import script from "./systemUserMember.vue?vue&type=script&lang=ts"
export * from "./systemUserMember.vue?vue&type=script&lang=ts"
import style0 from "./systemUserMember.vue?vue&type=style&index=0&id=12100106&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12100106",
  null
  
)

export default component.exports